const NotesReducers = (state = [], action) => {
    switch (action.type) {
        case "NOTES_LOADING":
            return {
                notes: [],
                isLoaded: false
            };
        case "NOTES_INITIAL":
            return {
                notes: action.data,
                isLoaded: true
            };
        default:
            return state;
    }
}

export default NotesReducers;